function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M.556 85.523H512v340.955H.556z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M0 315.298h511.444V85.52H0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M100.065 315.298V85.52H0v340.962h511.444-411.379z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#a2001d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M68.564 243.647l-18.531-33.619 18.531-33.091 18.529 33.091z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.502 243.647l-18.53-33.619 18.53-33.091 18.531 33.091zm37.062 91.417l-18.531-33.618 18.531-33.092 18.529 33.092zm-37.062 0l-18.53-33.618 18.53-33.092 18.531 33.092zm37.062 91.418l-18.531-33.619 18.531-33.092 18.529 33.092zm-37.062 0l-18.53-33.619 18.53-33.092 18.531 33.092zM68.564 152.23l-18.531-33.619 18.531-33.093 18.529 33.093z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.502 152.23l-18.53-33.619 18.53-33.093 18.531 33.093z"
}));

const SvgBelarus = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBelarus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/belarus.96eead14.svg";
export { ForwardRef as ReactComponent };